import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import { LicenseManager } from "ag-grid-enterprise/main";
LicenseManager.setLicenseKey(
  "MiraeWeb_Inc._on_behalf_of_Tradlinx_Inc_Lingo_application_1Devs1_SaaS_5_October_2019__MTU3MDIzMDAwMDAwMA==5b3e4254d1776542a13fdec4bcb19261"
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts